import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';

import {isMainJASO, JASO, MAIN_JASO_LIST, MAIN_JASO, SUB_INDEX_MAP, findMainJasoList} from '../../defines/gukeo.const';
import {SearchParam} from '../../defines/client.const';
import {GlobalEventService} from "../../services/global-event/global-event.service";


@Component({
  selector: 'app-jaso-index',
  templateUrl: './jaso-index.component.html',
  styleUrls: ['./jaso-index.component.scss'],
})
export class JasoIndexComponent implements OnInit, OnChanges {
  @Input() curJasoIdx: JASO | null = null;
  @Input() second = false;  // 2차 색인으로 들어갈 지 여부.
  @Input() set btnSize(value: number) {
    this.elementRef.nativeElement.style.setProperty('--jaso-btn-size', value + 'px');
  }
  @Input() set rightStart(value: number) {
    this.elementRef.nativeElement.style.setProperty('--jaso-right-start', value + 'px');
  }
  @Output() search: EventEmitter<SearchParam>;

  protected jasoList: Array<JASO> = MAIN_JASO_LIST;
  protected mainJaso: MAIN_JASO | null = null; // 메인 자소 (2차 자소로 들어갈 때 저장해 놓는다. 복구를 위해서)

  constructor(
    private elementRef: ElementRef,
    private globalEventSvc: GlobalEventService,
  ) {
    this.search = new EventEmitter<SearchParam>();
  }

  ngOnInit() {
    this.changeJasoIdx(this.curJasoIdx);
  }

  ngOnChanges(changes: SimpleChanges) {
    // changes 객체는 변경된 @Input() 값들의 현재 및 이전 값을 포함합니다.
    const change = changes['curJasoIdx'];

    // console.warn('JasoIndexComponent::ngOnChanges', this.curJasoIdx, change.previousValue, change.currentValue);
    if (change && change.previousValue !== change.currentValue
      && (change.previousValue !== undefined)) {
      // console.warn('curJasoIdx 이전 값:', change.previousValue);
      // console.warn('curJasoIdx 현재 값:', change.currentValue);

      this.changeJasoIdx(change.currentValue);
    }
  }

  public get offsetHeight(): number {
    return this.elementRef.nativeElement.offsetHeight;
  }

  public onClickJasoIdx($event: MouseEvent, jaso: JASO | null): void {
    $event.stopPropagation();
    $event.preventDefault();
    this.globalEventSvc.Click($event, true);

    this.changeJasoIdx(jaso, true);
  }


  /**
   * 자소 색인을 변경한다.
   * @param jaso
   * @param emit - emit를 할지 여부. 컴포넌트 외부에서 주어진 값인 경우, 다시 밖으로 emit를 할 필요가 없다. (불필요하고, 꼬이게 만든다)
   */
  private changeJasoIdx(jaso: string | null, emit: boolean = false) {
    // console.warn('JasoIndexComponent::changeJasoIdx', jaso, this.curJasoIdx);

    // if (this.curJasoIdx !== jaso)  // 이미 바뀐 상태로 여기로 오기때문에 비교가 의미가 없다.
    {
      this.curJasoIdx = jaso;

      if (jaso === null) {
        this.jasoList = MAIN_JASO_LIST;
        this.mainJaso = null;

        if (emit) {
          this.search.emit({});
        }
      } else {
        if (this.second) {
          if (isMainJASO(jaso)) {
            const subJasoList = SUB_INDEX_MAP.get(jaso);
            this.jasoList = subJasoList ?? MAIN_JASO_LIST;
            this.mainJaso = subJasoList ? jaso : null;  // 메인 자소라도 2차 색인이 없으면, null로 설정한다.
          } else {
            // SUB_INDEX_MAP 를 뒤져서 jaso에 들어있는 인덱스를 넣는다.
            [this.mainJaso, this.jasoList] = findMainJasoList(jaso) ?? [null, MAIN_JASO_LIST as string[]];
          }
        }

        if (emit) {
          this.search.emit({index: jaso,});
        }
      }
    }
  }
}
